import "./solicitudesA2.scss";
import "../../../../components/atoms/buttons/button.scss";
import { memo } from "react";
import React, { useState, useEffect } from "react";
import "../../../../pages/login/login.scss";
import "@fortawesome/fontawesome-free/scss/fontawesome.scss";
import "@fortawesome/fontawesome-free/scss/solid.scss";
import ConstantesTabla from "../../../../utils/ConstantesTabla";
import DataTable from "react-data-table-component";
import ModalMensajes from "../../modals/modalMensajes/ModalMensajes";
import { SpinnerCircleMini } from "../../../../components/atoms/spinner/Spinner";
import { useNavigate } from "react-router-dom";

const SolicitudesA2 = ({ solicitudesA2 }) => {
  const [showFeeback] = useState(false);
  const [descargandoPDF, setDescargandoPDF] = useState(true);
  const navigate = useNavigate();

  const marginTop = {
    marginTop: "20px",
  };
  const [isInitialRender, setIsInitialRender] = useState(true);

  useEffect(() => {
    if (isInitialRender) {
      setIsInitialRender(false);

      localStorage.setItem(
        "presentada",
        JSON.stringify(
          solicitudesA2.filter((data) => data.estado === "PRESENTADA")
            .length === 1
        )
      );
    }
  }, [isInitialRender, solicitudesA2]);
  const [show, setShow] = useState({
    mensaje: false,
  });

  const handleClose = (e) => {
    setShow(false);
  };

  const accionRec = {
    name: "Acción",
    right: true,
    cell: (row) =>
      row.estado === "PRESENTADA" ? (
        descargandoPDF ? (
          <i
            className="fa-solid fa-print fs-3 mx-2 px-3 cursorPointer faHover"
            onClick={() => {
              setDescargandoPDF(false);
              // getPDFA1A2(row.xweespeca1a2,"A2").then((data) => {
              //   if (!data.toString().startsWith("Error:")) {
              //     const file = new Blob([data], {
              //       type: "application/pdf",
              //     });
              //     if (file.size !== 0) {
              //       const fileURL = URL.createObjectURL(file);
              //       const link = document.createElement("a");
              //       link.href = fileURL;
              //       link.download = `A2_${row.xweespeca1a2}.pdf`;
              //       link.click();
              //       link.remove();
              //       setShowFeedback(false);
              //       setDescargandoPDF(true);
              //     } else {
              //       setShowFeedback(true);
              //       setDescargandoPDF(false);
              //     }
              //   } else {
              //     setShowFeedback(true);
              //     setDescargandoPDF(false);
              //   }
              // });
            }}
          ></i>
        ) : (
          <SpinnerCircleMini clases="mx-4"></SpinnerCircleMini>
        )
      ) : (
        <i
          className="fa-solid fa-eye fs-3 mx-2 px-3 cursorPointer faHover"
          onClick={() => {
            navigate(`/solicitudAdquisicionA2/${row.xweespeca1a2}`);
          }}
        ></i>
      ),
  };

  return (
    <>
      <div className="container-fluid" style={{ marginTop: "0px" }} role="main" data-landmark-index="4">
        <div>
          <div style={marginTop}>
            <DataTable
              className="table-responsive"
              columns={[...ConstantesTabla.columnasSolicitudesA1A2, accionRec]}
              data={solicitudesA2}
              pagination
              paginationComponentOptions={ConstantesTabla.paginacionOpt}
              noDataComponent={<span>No se encontró ninguna solicitud</span>}
              customStyles={ConstantesTabla.customStyles}
              fixedHeader
              fixedHeaderScrollHeight="600px"
              style={marginTop}
            />
          </div>
        </div>
      </div>
      {showFeeback
        ? setShow({
            mensaje: true,
            content: "No se ha podido descargar el PDF",
            tipo: "tituloModal",
          })
        : null}
      {show.mensaje ? (
        <ModalMensajes
          show={show.mensaje}
          handleClose={handleClose}
          titulo={show.titulo}
          tipo={show?.tipo}
          content={show?.content}
          content2={show?.content2}
          contentBold={show?.contentBold}
          otherContent={show?.otherContent}
          destinoCerrar={show?.destinoCerrar}
        ></ModalMensajes>
      ) : null}
    </>
  );
};

export default memo(SolicitudesA2);
